// extracted by mini-css-extract-plugin
module.exports = {"loading":"FinanceReportForm_loading__2WvMO","switchStyle":"FinanceReportForm_switchStyle__1TKXe"};